import React from 'react';

import Content from './General/Content';
import Filters from './General/Filters';
import { LabelMultiSelectFilter } from './Filters';
import SubmitFilter from './Filters/SubmitFilter';
import BridgingLoanTable from './InterestTables/BridgingLoanTable';

import { BRIDGING_LOANS, MAX_AMOUNT_SELECTED } from '../../Constants/Interest/Filter';
import { Filter } from '../../Enum/Filters';

const BridgingLoan: React.FC = () => (
    <div className="interest-content-wrapper" data-testid="interest-bridging-loans">
        <Filters>
            <SubmitFilter filterProperties={BRIDGING_LOANS} allowEmptyArray />
            <hr />
            <LabelMultiSelectFilter label="Filter op product"
                                    placeholder="Productnaam"
                                    filterType={Filter.BridgingLoanLabels}
                                    maxAmountSelectedLabels={MAX_AMOUNT_SELECTED}
                                    showExistingCustomers
            />
        </Filters>
        <Content>
            <BridgingLoanTable />
        </Content>
    </div>
);

export default BridgingLoan;
